import "./page-comparison-behavior"
import "./toggle-product"